import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { CompanionBody } from "@/components/CampusCompanion";

// "Ask jeeo" overlay — the Companion available from any page via the header button.
export default function AskJeeoModal({ open, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="ask-jeeo-modal"
          className="fixed inset-0 z-[2000] bg-black/40 backdrop-blur-sm flex items-start justify-center p-4 pt-20 sm:pt-24"
        >
          <motion.div
            initial={{ opacity: 0, y: -16, scale: 0.98 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -16, scale: 0.98 }}
            transition={{ type: "spring", stiffness: 320, damping: 26 }}
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-md bg-white rounded-2xl border border-border shadow-2xl p-5 relative"
          >
            <button
              data-testid="ask-jeeo-close"
              onClick={onClose}
              className="absolute top-3.5 right-3.5 p-1.5 rounded-md text-muted-foreground hover:bg-secondary transition-colors"
            >
              <X size={18} strokeWidth={2} />
            </button>
            <CompanionBody onClose={onClose} autoFocus />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
